var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { attrs: { bordered: false } },
            [
              _c("div", { staticClass: "workbench-header" }, [
                _c(
                  "div",
                  { staticClass: "workbench-title" },
                  [
                    _c(
                      "a-button",
                      {
                        staticStyle: { "margin-right": "12px" },
                        attrs: { icon: "arrow-left" },
                        on: { click: _vm.goBack },
                      },
                      [_vm._v("返回")]
                    ),
                    _c("span", [
                      _vm._v("发图单：" + _vm._s(_vm.order.billNo || "-")),
                    ]),
                    _vm.order.status === "0"
                      ? _c(
                          "a-tag",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { color: "orange" },
                          },
                          [_vm._v("待校正")]
                        )
                      : _c(
                          "a-tag",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { color: "green" },
                          },
                          [
                            _vm._v(
                              "已生成订单 " +
                                _vm._s(
                                  _vm.order.orderHeadId
                                    ? "(" + _vm.order.orderHeadId + ")"
                                    : ""
                                )
                            ),
                          ]
                        ),
                    _c(
                      "span",
                      { staticStyle: { "margin-left": "16px", color: "#888" } },
                      [_vm._v("客户：" + _vm._s(_vm.order.customerName || "-"))]
                    ),
                  ],
                  1
                ),
                _vm.order.status === "0"
                  ? _c(
                      "div",
                      [
                        !_vm.xsddMultiOn
                          ? _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "check",
                                  disabled: !_vm.canGenerate,
                                  loading: _vm.generating,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleGenerate(false)
                                  },
                                },
                              },
                              [_vm._v("生成订单")]
                            )
                          : _vm._e(),
                        !_vm.xsddMultiOn || !_vm.xsddFlowOn
                          ? _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "8px" },
                                attrs: {
                                  type: "primary",
                                  icon: "check",
                                  disabled: !_vm.canGenerate,
                                  loading: _vm.generating,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleGenerate(true)
                                  },
                                },
                              },
                              [_vm._v("生成并审核")]
                            )
                          : _vm._e(),
                        _vm.xsddMultiOn && _vm.xsddFlowOn
                          ? _c(
                              "a-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "check",
                                  disabled: !_vm.canGenerate,
                                  loading: _vm.generating,
                                },
                                on: { click: _vm.handleGenerateFlow },
                              },
                              [_vm._v("生成并提交流程")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.order.status === "0" &&
              _vm.images.length > 0 &&
              !_vm.allCorrected
                ? _c("a-alert", {
                    staticStyle: { "margin-bottom": "12px" },
                    attrs: {
                      type: "info",
                      "show-icon": "",
                      message:
                        "逐张图片完成 OCR 识别 → 点击行框挂接商品/数量 → 保存本图校正；全部图片校正完成后可生成销售订单",
                    },
                  })
                : _vm._e(),
              !_vm.orderId
                ? _c("a-alert", {
                    attrs: {
                      type: "warning",
                      "show-icon": "",
                      message:
                        "缺少发图单参数，请从【收单中心 → 发图订单】列表进入",
                    },
                  })
                : _vm._e(),
              _vm.orderId && _vm.images.length > 0
                ? _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("a-col", { attrs: { span: 5 } }, [
                        _c(
                          "div",
                          { staticClass: "img-list" },
                          _vm._l(_vm.images, function (img) {
                            return _c(
                              "div",
                              {
                                key: img.id,
                                staticClass: "img-item",
                                class: {
                                  active: _vm.currentImageId === img.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectImage(img.id)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-thumb",
                                  attrs: { src: img.imgUrl },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "img-item-footer" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "img-item-name" },
                                      [_vm._v("图" + _vm._s(img.id))]
                                    ),
                                    _c(
                                      "a-tag",
                                      {
                                        staticClass: "img-item-tag",
                                        attrs: {
                                          color: _vm.ocrStatusColor(
                                            img.ocrStatus
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ocrStatusName(img.ocrStatus)
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _c(
                        "a-col",
                        { attrs: { span: 19 } },
                        [
                          _c(
                            "div",
                            { staticClass: "img-toolbar" },
                            [
                              _vm.order.status === "0"
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        icon: "scan",
                                        disabled:
                                          !_vm.currentImage ||
                                          _vm.currentImage.ocrStatus !== "0",
                                        loading: _vm.ocrRunning,
                                      },
                                      on: { click: _vm.handleRunOcr },
                                    },
                                    [_vm._v("识别图片(OCR)")]
                                  )
                                : _vm._e(),
                              _vm.order.status === "0"
                                ? _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        type: _vm.drawMode
                                          ? "primary"
                                          : "dashed",
                                        icon: "edit",
                                        disabled:
                                          !_vm.currentImage ||
                                          _vm.currentImage.ocrStatus === "0",
                                      },
                                      on: { click: _vm.toggleDrawMode },
                                    },
                                    [_vm._v("增加标注")]
                                  )
                                : _vm._e(),
                              _vm.order.status === "0"
                                ? _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        disabled:
                                          !_vm.currentImage ||
                                          _vm.currentImage.ocrStatus === "0",
                                        loading: _vm.saving,
                                      },
                                      on: { click: _vm.handleSaveCorrections },
                                    },
                                    [_vm._v("保存本图校正")]
                                  )
                                : _vm._e(),
                              _vm.currentImage
                                ? _c(
                                    "span",
                                    { staticClass: "img-toolbar-hint" },
                                    [
                                      _vm._v(
                                        "\n              单击框选中（可拖动/缩放/Delete删除），双击框编辑内容，增加标注补漏识别行\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.currentImage
                            ? _c(
                                "div",
                                { staticClass: "img-stage-wrap" },
                                [
                                  _vm.lines.length > 0 && _vm.naturalWidth > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "img-stage",
                                          class: { "draw-mode": _vm.drawMode },
                                          on: { click: _vm.onStageClick },
                                        },
                                        [
                                          _c("img", {
                                            ref: "mainImage",
                                            staticClass: "img-main",
                                            attrs: {
                                              src: _vm.currentImage.imgUrl,
                                            },
                                            on: {
                                              load: _vm.onImgLoad,
                                              error: _vm.onImgError,
                                              mousedown: _vm.onDrawMouseDown,
                                            },
                                          }),
                                          _vm._l(
                                            _vm.positionedLines,
                                            function (line) {
                                              return _c(
                                                "div",
                                                {
                                                  key: line.lineIndex,
                                                  staticClass: "ocr-box",
                                                  class: [
                                                    _vm.lineColor(line) ===
                                                    "green"
                                                      ? "ocr-box-green"
                                                      : "ocr-box-red",
                                                    {
                                                      "ocr-box-selected":
                                                        line.lineIndex ===
                                                        _vm.selectedLineIndex,
                                                    },
                                                  ],
                                                  style: _vm.boxStyle(line),
                                                  attrs: { title: line.text },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.selectLine(
                                                        line
                                                      )
                                                    },
                                                    dblclick: function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      return _vm.openLine(line)
                                                    },
                                                    mousedown: function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      return _vm.onBoxMouseDown(
                                                        $event,
                                                        line
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ocr-box-index",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          line.lineIndex >= 0
                                                            ? line.lineIndex + 1
                                                            : "新"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.edits[line.lineIndex] &&
                                                  _vm.edits[line.lineIndex]
                                                    .saveAlias
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ocr-box-alias",
                                                          attrs: {
                                                            title:
                                                              "已勾选记为别名",
                                                          },
                                                        },
                                                        [_vm._v("别")]
                                                      )
                                                    : _vm._e(),
                                                  line.lineIndex ===
                                                  _vm.selectedLineIndex
                                                    ? _c("span", {
                                                        staticClass:
                                                          "ocr-box-resize",
                                                        on: {
                                                          mousedown: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.onResizeMouseDown(
                                                              $event,
                                                              line
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm.drawingBox
                                            ? _c("div", {
                                                staticClass: "drawing-box",
                                                style: _vm.boxStyle(
                                                  _vm.drawingBox
                                                ),
                                              })
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : !_vm.imgLoadError
                                    ? _c("div", { staticClass: "img-stage" }, [
                                        _c("img", {
                                          ref: "mainImage",
                                          staticClass: "img-main",
                                          attrs: {
                                            src: _vm.currentImage.imgUrl,
                                          },
                                          on: {
                                            load: _vm.onImgLoad,
                                            error: _vm.onImgError,
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm.imgLoadError
                                    ? _c("a-alert", {
                                        attrs: {
                                          type: "error",
                                          "show-icon": "",
                                          message:
                                            "图片加载失败：" +
                                            _vm.currentImage.imgUrl,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.plainLines.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "plain-lines" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "plain-lines-title",
                                            },
                                            [
                                              _vm._v(
                                                "以下识别行无位置信息（点击文字编辑，尾部 × 删除）："
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.plainLines,
                                            function (line) {
                                              return _c(
                                                "div",
                                                {
                                                  key: line.lineIndex,
                                                  staticClass: "plain-line",
                                                },
                                                [
                                                  _c(
                                                    "a-tag",
                                                    {
                                                      attrs: {
                                                        color:
                                                          _vm.lineColor(
                                                            line
                                                          ) === "green"
                                                            ? "green"
                                                            : "red",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          line.lineIndex + 1
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "plain-line-text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openLine(
                                                            line
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(line.text))]
                                                  ),
                                                  _vm.order.status === "0"
                                                    ? _c("a-icon", {
                                                        staticClass:
                                                          "plain-line-del",
                                                        attrs: {
                                                          type: "close",
                                                          title: "删除该行",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteLineByIndex(
                                                              line.lineIndex
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.lines.length > 0 &&
                                  _vm.naturalWidth === 0 &&
                                  !_vm.imgLoadError
                                    ? _c(
                                        "div",
                                        { staticClass: "plain-lines-hint" },
                                        [
                                          _vm._v(
                                            "图片加载中，行位置框将在图片加载后显示"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c("a-empty", {
                                staticStyle: { "margin-top": "80px" },
                                attrs: { description: "请从左侧选择图片" },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.orderId
                ? _c("a-empty", {
                    staticStyle: { "margin-top": "80px" },
                    attrs: { description: "该发图单暂无图片" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title:
              _vm.editingLine.lineIndex >= 0
                ? "校正第 " + (_vm.editingLine.lineIndex + 1) + " 行"
                : "新增标注行",
            width: 560,
            visible: _vm.lineModalVisible,
            confirmLoading: _vm.lineSaving,
            maskClosable: false,
            wrapClassName: "line-edit-modal",
            cancelText: "取消",
            okText: "确定",
          },
          on: {
            ok: _vm.handleLineOk,
            cancel: function ($event) {
              _vm.lineModalVisible = false
            },
          },
        },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "识别文字",
                    required: "",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "识别出的文字，可修改" },
                    on: { blur: _vm.onTextBlur },
                    model: {
                      value: _vm.editingLine.text,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLine, "text", $$v)
                      },
                      expression: "editingLine.text",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "挂接商品",
                    extra:
                      "搜索选择本租户商品；不挂接商品或不填数量的行不会进入订单",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "输入名称搜索商品",
                        "show-search": "",
                        "allow-clear": "",
                        "filter-option": false,
                      },
                      on: { search: _vm.handleSearchMaterial },
                      model: {
                        value: _vm.editingLine.materialId,
                        callback: function ($$v) {
                          _vm.$set(_vm.editingLine, "materialId", $$v)
                        },
                        expression: "editingLine.materialId",
                      },
                    },
                    _vm._l(_vm.materialList, function (m) {
                      return _c(
                        "a-select-option",
                        { key: m.id, attrs: { value: m.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                m.unit ? m.name + "（" + m.unit + "）" : m.name
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "数量",
                  },
                },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, precision: 2, placeholder: "请输入数量" },
                    model: {
                      value: _vm.editingLine.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLine, "quantity", $$v)
                      },
                      expression: "editingLine.quantity",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "单位",
                    extra: _vm.unitHint,
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "留空则按商品档案单位" },
                    model: {
                      value: _vm.editingLine.unit,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLine, "unit", $$v)
                      },
                      expression: "editingLine.unit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "备注",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "选填，如多数量原文（3斤+8斤）/规格说明",
                    },
                    model: {
                      value: _vm.editingLine.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLine, "remark", $$v)
                      },
                      expression: "editingLine.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.modalLabelCol,
                    wrapperCol: _vm.modalWrapperCol,
                    label: "记为别名",
                    extra:
                      "勾选后将该行原始识别文字的商品名段记为所挂接商品的别名（错字→正确商品映射），下次OCR自动命中",
                  },
                },
                [
                  _c("a-checkbox", {
                    attrs: { disabled: !_vm.editingLine.materialId },
                    model: {
                      value: _vm.editingLine.saveAlias,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingLine, "saveAlias", $$v)
                      },
                      expression: "editingLine.saveAlias",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }